import { createRouter, createWebHistory } from 'vue-router'
import SessionHelper from '@/utils/session';
import HomeView from '@/views/HomeView'
import LoginView from "@/views/LoginView"
import UsersView from '@/views/UsersView'
import UserForm from '@/views/UserForm'
import ApprovalView from '@/views/ApprovalView'
import RankingView from '@/views/RankingView'
import CurrentRound from '@/views/CurrentRound'
import SaveBetting from '@/views/SaveBetting'
import BetRules from '@/views/BetRules'
import BettingSaved from '@/views/BettingSaved'
import ReportsBetting from '@/views/ReportsBetting'
import StandingsView from '@/views/StandingsView'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: LoginView
  },
  {
    path: "/users/:userId?",
    name: "Users",
    component: UsersView,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/user-form/:userId?",
    name: "UserForm",
    component: UserForm,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/approval",
    name: "Approval",
    component: ApprovalView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/ranking",
    name: "ranking",
    component: RankingView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/current-round/:userId?/:roundId?",
    name: "Current Round",
    component: CurrentRound,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/new-betting/:userId/:roundId?',
    name: "NewBetting",
    component: SaveBetting,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/bet-rules",
    name: "Bet Rules",
    component: BetRules,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/betting-saved/:roundId?",
    name: "Betting Saved",
    component: BettingSaved,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/reports-betting/:roundId?",
    name: "Reports Betting",
    component: ReportsBetting,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/standings/:roundId?",
    name: "Standings",
    component: StandingsView,
    meta: {
      requiresAuth: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  // Token expirado conta como ausente: senão o guard mandava o usuário para
  // a home, a home tomava 401 e voltava para /login em loop.
  const token = SessionHelper.getValidToken()

  if (token) {
    SessionHelper.applyAuthHeader(token)
  }

  // Se o usuário está autenticado e tentando acessar a página de login, redireciona para home
  if (to.path === '/login' && token) {
    next({ path: '/' })
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    next({ path: '/login' })
    return
  }

  next() // make sure to always call next()!
})

export default router
